import React from 'react';
import CsvToJson from './components/CsvToJson';

const App: React.FC = () => {
  return (
    <div className="App">
      <CsvToJson />
    </div>
  );
};

export default App;
